import InsuranceEligibilityValidatorTool from 'components/InsuranceEligibilityValidatorTool'

const EmbedInsuranceEligibilityValidatorTool: React.FC = () => (
  <InsuranceEligibilityValidatorTool variant="guide" />
)

export default EmbedInsuranceEligibilityValidatorTool
